import React, { useState, useEffect } from 'react';
import TopBar from '@/Components/TopBar'

const Component = (props: any) => {
return (
<TopBar title='在线优化' />
);
};

export default Component;